export {
  effectiveStatus,
  presenceDescription,
  serverNow,
  statusDuration,
} from "../shared/presence";

import type { AgentView } from "../shared/contracts";
import { PRESENCE_TTL_MS } from "../shared/contracts";
import { effectiveStatus } from "../shared/presence";

export function isOnline(
  agent: Pick<AgentView, "status" | "lastSeen" | "evidence">,
  now: number,
  disconnected = false,
): boolean {
  if (disconnected || !Number.isFinite(now) || agent.status === "offline")
    return false;
  const lastSeen = agent.lastSeen;
  if (
    lastSeen === null ||
    !Number.isFinite(lastSeen) ||
    lastSeen > now + 5_000 ||
    now - lastSeen >= PRESENCE_TTL_MS
  )
    return false;
  const evidence = agent.evidence;
  if (
    evidence &&
    (evidence.health === "restricted" ||
      evidence.reason === "no_observation" ||
      !Number.isFinite(evidence.tabCount) ||
      evidence.tabCount <= 0)
  )
    return false;
  return effectiveStatus(agent, now) !== "offline";
}
